import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { rowData } from 'assets/data/data';
import { Group, GROUP_ICON, GroupItem } from 'app/models/recipe.model';



@Injectable()
export class IngrediantService {
	private dataRead: Group[] = [];
	constructor() {
	}

	private initData = () => {
		let data = []
		let trimmedData = rowData.map((element) =>{
			for (let key in element) {
				if (typeof(element[key]) === 'string') {
					element[key] = element[key].trim();
				} 
			}
			let el: any = new Object();
			Object.assign(el, element);
			
			el.frequencyOfConsumption = (""+element.frequencyOfConsumption).trim();
			return el;
		})

		trimmedData.forEach((element) => {
			
			let found = data.find((el) => {
				return el.id.trim().toUpperCase() == element['FOOD COMMODITY GROUP'].trim().toUpperCase();
			})
			
			let group: Group = null;
			if (found) group = found;
			else {
				group = {
					id: element['FOOD COMMODITY GROUP'],
					secureId: element['FOOD COMMODITY GROUP'].split("&").join("_").split(" ").join("").split("-").join(""),
					icon: GROUP_ICON[""+element['FOOD COMMODITY GROUP']],
					subgroups: [], items: []
				};
				data.push(group);
			}

			if (element['FOOD COMMODITY SUB-GROUP'] && element['FOOD COMMODITY ITEM']) {
				found = group.subgroups.find((el) => {
					return el.id.trim().toUpperCase() == element['FOOD COMMODITY SUB-GROUP'].trim().toUpperCase();
				})
				let subgroup: Group = null;
				if (found) subgroup = found;
				else {
					subgroup = {
						id: element['FOOD COMMODITY SUB-GROUP'],
						secureId: element['FOOD COMMODITY SUB-GROUP'].split("&").join("_").split(" ").join("").split("-").join(""),
						subgroups: [], items: []
					};
					group.subgroups.push(subgroup);
				};
				// if (element['FOOD COMMODITY ITEM']) {
					element["id"] = element['FOOD COMMODITY ITEM'];
					subgroup.items.push(<any>element);
				// }
				
					
			}
			else {
				// if (element['FOOD COMMODITY ITEM']) {
					// element["id"] = element['FOOD COMMODITY ITEM'];
					// group.items.push(<any>element);
				// }
				element["id"] = element['FOOD COMMODITY SUB-GROUP'];
				group.items.push(<any>element);

			}

		});
		this.dataRead = data;
	}
	public getAll = (): Observable<Group[]> => {
		if (!this.dataRead || this.dataRead.length == 0)
			this.initData();
		return of(this.dataRead);
	}

	public getItem = (groupId, subgroupId, itemId): GroupItem => {
		if (!this.dataRead || this.dataRead.length == 0)
			this.initData();

		let found: GroupItem = null;
		this.dataRead.forEach((group) => {
			group.items.forEach((item) => {
				if (group.id == groupId && item.id == subgroupId && (!itemId || itemId == "")) {
					found = item;
				}
			})
			group.subgroups.forEach((subgroup) => {
				subgroup.items.forEach((item_s) => {
					if (group.id == groupId && subgroup.id == subgroupId && item_s.id == itemId) {
						found = item_s;
					}
				})
			})
		})
		return found;
	}
}

